// Gözləməyə alınmış çeklər (KT-101): cihazda, kassa üzrə (localStorage). İnternetsiz də işləyir; hər çekin öz UUID-i var —
// geri çağırılıb satılanda həmin UUID ilə gedir (təkrar göndərilsə bir sənəd, KT-79). Brauzer yaddaşı əlçatmazdırsa boş siyahı.

export interface HeldLine {
  productId: string;
  name: string;
  unit: string;
  price: number;
  qty: number;
  discount: number;
  fallback?: boolean;
}

export interface HeldCheck {
  id: string;
  heldAt: string;
  customerId: string;
  lines: HeldLine[];
}

const key = (registerId: string) => `kassa.held.${registerId}`;

export function heldList(registerId: string): HeldCheck[] {
  if (!registerId) return [];
  try {
    const raw = localStorage.getItem(key(registerId));
    const v: unknown = raw ? JSON.parse(raw) : [];
    return Array.isArray(v) ? (v as HeldCheck[]).filter((h) => h && typeof h.id === 'string' && Array.isArray(h.lines)) : [];
  } catch {
    return [];
  }
}

function save(registerId: string, list: HeldCheck[]): boolean {
  try {
    localStorage.setItem(key(registerId), JSON.stringify(list));
    return true;
  } catch {
    return false;
  }
}

/** Çeki gözləməyə alır; yaddaşa yazmaq alınmasa false (səbət təmizlənməsin). */
export function holdCheck(registerId: string, check: HeldCheck): boolean {
  return save(registerId, [...heldList(registerId).filter((h) => h.id !== check.id), check]);
}

export function removeHeld(registerId: string, id: string): void {
  save(registerId, heldList(registerId).filter((h) => h.id !== id));
}
